import { hasSystemAdminRole } from '../../../utils/roles';
import FeatureFormItem from './FeatureFormItem';
import SettingSectionWrapper from './SettingSectionWrapper';

const NotificationSettingsFormItems = props => {
  const { t, authUser, companySettings, onFeatureChange, disabled } = props;

  if (!hasSystemAdminRole(authUser)) return null;

  return (
    <SettingSectionWrapper title={t('notificationSettings')}>
      <FeatureFormItem
        label={t('favrAlerts')}
        value={companySettings.favrAlerts}
        onChange={checked => onFeatureChange({ favrAlerts: checked })}
      />

      <FeatureFormItem
        label={t('sendBusinessMileageComplianceEmailNotification')}
        value={companySettings.businessMileageComplianceEmailNotification}
        onChange={checked =>
          onFeatureChange({ businessMileageComplianceEmailNotification: checked })
        }
      />

      <FeatureFormItem
        label={t('defaultVehicleOutOfComplianceEmailNotification')}
        value={companySettings.defaultVehicleOutOfComplianceEmailNotification}
        onChange={checked =>
          onFeatureChange({ defaultVehicleOutOfComplianceEmailNotification: checked })
        }
      />

      <FeatureFormItem
        label={t('sendExpiredInsurancePolicyEmailNotification')}
        value={companySettings.expiredInsurancePolicyEmailNotification}
        onChange={checked => onFeatureChange({ expiredInsurancePolicyEmailNotification: checked })}
      />

      <FeatureFormItem
        label={t('sendInsuranceOutOfComplianceEmailNotification')}
        value={companySettings.insuranceOutOfComplianceEmailNotification}
        onChange={checked =>
          onFeatureChange({ insuranceOutOfComplianceEmailNotification: checked })
        }
      />

      <FeatureFormItem
        label={t('sendMissingDefaultVehicleEmailNotification')}
        value={companySettings.missingDefaultVehicleEmailNotification}
        onChange={checked => onFeatureChange({ missingDefaultVehicleEmailNotification: checked })}
      />

      <FeatureFormItem
        label={t('sendNextPaymentPeriodPushNotification')}
        value={companySettings.sendNextPaymentPeriodPushNotification}
        onChange={checked => onFeatureChange({ sendNextPaymentPeriodPushNotification: checked })}
        disabled={disabled}
      />

      <FeatureFormItem
        label={t('sendSubmitInsuranceInformationEmailNotification')}
        value={companySettings.submitInsuranceInformationEmailNotification}
        onChange={checked =>
          onFeatureChange({ submitInsuranceInformationEmailNotification: checked })
        }
      />

      <FeatureFormItem
        label={t('autoTrackingMisconfigurationNotifications')}
        value={companySettings.autoTrackingMisconfigurationNotifications}
        onChange={checked =>
          onFeatureChange({
            autoTrackingMisconfigurationNotifications: checked,
          })
        }
      />

      <FeatureFormItem
        label={t('sendCompanyAdminReimbursementNotification')}
        value={companySettings.sendCompanyAdminReimbursementNotification}
        onChange={checked =>
          onFeatureChange({ sendCompanyAdminReimbursementNotification: checked })
        }
      />
    </SettingSectionWrapper>
  );
};

export default NotificationSettingsFormItems;
